<template>
  <div class="widget-handler">
    <TextWidgetConfig @changeConfig="changeConfig" :element="element" v-if="widgetName=='text'"/>
    <ImageWidgetConfig  @changeConfig="changeConfig" :element="element" v-if="widgetName=='image'"/>
    <QrWidgetConfig  @changeConfig="changeConfig" :element="element" v-if="widgetName=='qr'"/>
  </div>
</template>

<script>

import TextWidgetConfig from './Widgets/Text/TextConfig';
import ImageWidgetConfig from './Widgets/Image/ImageConfig';
import QrWidgetConfig from "./Widgets/Qr/QrWidgetConfig";

export default {
  name: "WidgetsConfigHandler",
  components: {
    QrWidgetConfig,
    TextWidgetConfig,
    ImageWidgetConfig
  },
  props: {
    widgetName: {},
    element: {}
  },
  methods:{
    changeConfig(data){
      this.$emit('changeConfig',data);
    }
  }
}
</script>

<style scoped>
.widget-handler {
  width: 100%;
  height: 100%;
}
</style>
